/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import { Row, Col, Container, Table, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  HeadingDescSmall,
  HeadingWithSpaceLarge,
  SectionHeadingMed
} from '../../../Components/Headings';
import { SharedTag } from '../../../Components/tags';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import { AncerWithUnderlineSmall } from '../../../Components/button';
import { SectionHeading } from '../../../Components/SectionHeading';
import addIcon from '../../../assets/images/png/add-icon.png';
import editIcon from '../../../assets/images/png/edit-table.png';
import shareIcon from '../../../assets/images/png/share-table.png';
import closeIcon from '../../../assets/images/png/close-table.png';
import arrowRgiht from '../../../assets/images/svg/right-arrow-border.svg';
import CardWithLeftImage from '../../../Components/Card/cardWithLeftImage/CardWithLeftImage';
import docImage from '../../../assets/images/png/doc.png';
import checkIcon from '../../../assets/images/svg/check-green.svg';
import closeIconLarge from '../../../assets/images/svg/close-icon-large.svg';
import './medicalRecordes.css';

const doctors = [
  {
    image: docImage,
    docName: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    availability: 'In-Person Appointment',
    time: 'Mar 31 - 5:40 am',
    status: false,
    place: 'The Doctor’s Plaza (Clifton)'
  },
  {
    image: docImage,
    docName: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    availability: 'In-Person Appointment',
    time: 'Mar 31 - 5:40 am',
    status: true,
    place: 'The Doctor’s Plaza (Clifton)'
  },
  {
    image: docImage,
    docName: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    availability: 'In-Person Appointment',
    time: 'Mar 31 - 5:40 am',
    status: true,
    place: 'The Doctor’s Plaza (Clifton)'
  },
  {
    image: docImage,
    docName: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    availability: 'In-Person Appointment',
    time: 'Mar 31 - 5:40 am',
    status: false,
    place: 'The Doctor’s Plaza (Clifton)'
  }
];

const medicalRecords = [
  {
    date: 'March 25, 2021',
    name: 'Alyna Butt (You)',
    reports: '3 Reports, 1 Prescription',
    shareWith: '3'
  },
  {
    date: 'March 25, 2021',
    name: 'Usman Butt (Brother)',
    reports: '2 Reports',
    shareWith: '1'
  },
  {
    date: 'March 25, 2021',
    name: 'Taha Irshad Ali (Brother)',
    reports: '2 Prescription',
    shareWith: '2'
  },
  {
    date: 'March 25, 2021',
    name: 'Faizan Desai (Husband)',
    reports: '1 Vaccination',
    shareWith: '2'
  }
];

function MedicalRecordes() {
  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  return (
    <HealthCheckLayout>
      <section className="medicalRecordes bgLinghtGray">
        <Container>
          <div className="addBox">
            <HeadingWithSpaceLarge text="MEDICAL RECORDS" />
            <Link to="/addEditMedicalRecords">
              <img src={addIcon} alt="addIcon" />
            </Link>
          </div>
          <Row>
            <Col md={12}>
              <div className="medicalRecordsTable innerBox">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Tests Taken on</th>
                      <th>Reports for</th>
                      <th>Total Reports</th>
                      <th>Shared with Doctor(s)</th>
                      <th> </th>
                    </tr>
                  </thead>
                  <tbody>
                    {medicalRecords.map((medicalRecord, index) => {
                      const { date, name, reports, shareWith } = medicalRecord;
                      return (
                        <tr key={index}>
                          <td>{date}</td>
                          <td>{name}</td>
                          <td>{reports}</td>
                          <td>{shareWith}</td>
                          <td>
                            <div className="btnContainer">
                              <div>
                                <img src={arrowRgiht} alt="arrowRgiht" />
                                <AncerWithUnderlineSmall
                                  to="/viewMedicalRecords"
                                  text="view"
                                />
                              </div>
                              <Link to="/addEditMedicalRecords">
                                <img src={editIcon} alt="editIcon" />
                              </Link>
                              <button
                                type="button"
                                onClick={() => setModal1(true)}
                              >
                                <img src={shareIcon} alt="editIcon" />
                              </button>
                              <button
                                type="button"
                                onClick={() => setModal2(true)}
                              >
                                <img src={closeIcon} alt="editIcon" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Col>
            <Modal
              show={modal1}
              className="modalLayout sharedReportDocModal"
              onHide={() => setModal1(false)}
              centered
              aria-labelledby="contained-modal-title-vcenter"
            >
              <Modal.Header closeButton onHide={() => setModal1(false)}>
                <div>
                  <HeadingWithSpaceLarge text="SHARE MEDICAL RECORD" />
                  <HeadingDescSmall text="You can share your records with the doctors you have visited." />
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="content">
                  {doctors.map((doctor, index) => {
                    const {
                      image,
                      docName,
                      speciality,
                      availability,
                      status,
                      time,
                      place
                    } = doctor;
                    return (
                      <CardWithLeftImage
                        key={index}
                        image={image}
                        heading={docName}
                        desc={speciality}
                      >
                        <div className="availability">
                          {status === true ? (
                            <div className="one">
                              <HeadingDescSmall text={availability} />
                            </div>
                          ) : (
                            <div className="two">
                              <HeadingDescSmall text="Video Consultation" />
                            </div>
                          )}
                        </div>
                        <div className="timePlace">
                          <HeadingDescSmall text={time} />
                          <HeadingDescSmall text="at" />
                          <Link className="place" to="/">
                            <HeadingDescSmall text={place} />
                          </Link>
                        </div>
                        <div className="shareStatus">
                          {status === false ? (
                            <SectionHeading
                              icon={<img src={shareIcon} alt="editIcon" />}
                              link={
                                <AncerWithUnderlineSmall
                                  text="share now"
                                  to="/"
                                />
                              }
                            />
                          ) : (
                            <SharedTag icon={checkIcon} text="shared" />
                          )}
                        </div>
                      </CardWithLeftImage>
                    );
                  })}
                </div>
              </Modal.Body>
            </Modal>
            <Modal
              show={modal2}
              className="modalLayout closeModal"
              onHide={() => setModal2(true)}
              centered
              aria-labelledby="contained-modal-title-vcenter"
            >
              <Modal.Body>
                <div className="content">
                  <img src={closeIconLarge} alt="closeIconLarge" />
                  <SectionHeadingMed text="Are you sure you want to delete this medical record?" />
                  <div className="btnsContainer">
                    <button
                      type="button"
                      onClick={() => setModal2(false)}
                      className="simple_btn success"
                    >
                      NO, GO BACK
                    </button>
                    <button type="button" className="simple_btn warning">
                      YES
                    </button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </Row>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default MedicalRecordes;
